export default "/images/framework/face_2.25e05cc9.png?25e05cc9";